// React Imports
import React from "react";
import { Route } from 'react-router';

// Page Imports
import NotFoundPage from './containers/NotFoundPage';
import HomePage from './containers/HomePage';
import CoreLayout from './layouts/CoreLayout';
import AboutPage from "./containers/AboutPage";

export default (
    <Route component={CoreLayout}>
        <Route path="/" component={HomePage}/>
        {/*<Route path="/folio" component={HomePage}/>*/}
        <Route path="/about" component={AboutPage}/>
        <Route path="*" component={NotFoundPage} status={404}/>
    </Route>
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/